import classNames from 'classnames';
import {connect} from 'react-redux';
import {defineMessages, FormattedMessage, injectIntl, intlShape} from 'react-intl';
import PropTypes from 'prop-types';
import bindAll from 'lodash.bindall';
import React from 'react';
import axios from '../../lib/services';
import Box from '../box/box.jsx';
import Button from '../button/button.jsx';
import ShareButton from './share-button.jsx';
import {ComingSoonTooltip} from '../coming-soon/coming-soon.jsx';
import LanguageSelector from '../../containers/language-selector.jsx';
import ShareTip from '../../containers/share-tip.jsx';
import ReactTooltip from 'react-tooltip';
import SaveStatus from './save-status.jsx';
import SBFileUploader from '../../containers/sb-file-uploader.jsx';
import MenuBarMenu from './menu-bar-menu.jsx';
import {MenuItem, MenuSection} from '../menu/menu.jsx';
import ProjectTitleInput from './project-title-input.jsx';
import AuthorInfo from './author-info.jsx';
import AccountNav from '../../containers/account-nav.jsx';
import LoginDropdown from './login-dropdown.jsx';
import SB3Downloader from '../../containers/sb3-downloader.jsx';
import DeletionRestorer from '../../containers/deletion-restorer.jsx';
import TurboMode from '../../containers/turbo-mode.jsx';
import {openTipsLibrary} from '../../reducers/modals';
import {setPlayer} from '../../reducers/mode';
import {setSubmitStatus} from '../../reducers/isSubmitStatus';
import MediaRecordModal from '../media-record/media-record.jsx';
import {
    autoUpdateProject,
    getIsLoadingUpload,
    getIsUpdating,
    getIsPublish,
    getIsShowingProject,
    manualPublishProject,
    manualUpdateProject,
    requestNewProject,
    remixProject,
    saveProjectAsCopy,
    setProjectId,
    requestNewProjectWithoutChangeId,
} from '../../reducers/project-state';
import {
    openAccountMenu,
    closeAccountMenu,
    accountMenuOpen,
    openFileMenu,
    closeFileMenu,
    fileMenuOpen,
    openEditMenu,
    closeEditMenu,
    editMenuOpen,
    openLanguageMenu,
    closeLanguageMenu,
    languageMenuOpen,
    openLoginMenu,
    closeLoginMenu,
    loginMenuOpen,
    showShare
} from '../../reducers/menus';
import {
    openShareModal,
    closeShareModal
} from '../../reducers/modals';

import {setStartRecord} from '../../reducers/record';

import styles from './menu-bar.css';

import mystuffIcon from './icon--mystuff.png';
import remixIcon from './icon--remix.svg';
import dropdownCaret from './dropdown-caret.svg';
import languageIcon from '../language-selector/language-icon.svg';

import { queryParams, getUserToken, getUserinfo } from '../../lib/services/query-params';

import logo from './logo.png';
import logoS from './logo-s@2x.png';
import projectHost from '../../lib/storage.js';
import swal from '../../lib/swal';
import errorMsg from '../../lib/errorMsg';
import {scratchView} from '../../utils/xes-analytice';

const messages = defineMessages({
    confirmNav: {
        id: 'gui.menuBar.confirmNewWithoutSaving',
        defaultMessage: 'Replace contents of the current project?',
        description: 'message for prompting user to confirm that they want to create new project without saving'
    }
});
const ariaMessages = defineMessages({
    language: {
        id: 'gui.menuBar.LanguageSelector',
        defaultMessage: 'language selector',
        description: 'accessibility text for the language selection menu'
    },
    tutorials: {
        id: 'gui.menuBar.tutorialsLibrary',
        defaultMessage: 'Tutorials',
        description: 'accessibility text for the tutorials button'
    }
});

const MenuBarItemTooltip = ({
    children,
    className,
    enable,
    id,
    place = 'bottom'
}) => {
    if (enable) {
        return (
            <React.Fragment>
                {children}
            </React.Fragment>
        );
    }
    return (
        <ComingSoonTooltip
            className={classNames(styles.comingSoon, className)}
            place={place}
            tooltipClassName={styles.comingSoonTooltip}
            tooltipId={id}
        >
            {children}
        </ComingSoonTooltip>
    );
};


MenuBarItemTooltip.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    enable: PropTypes.bool,
    id: PropTypes.string,
    place: PropTypes.oneOf(['top', 'bottom', 'left', 'right'])
};

const MenuItemTooltip = ({id, isRtl, children, className}) => (
    <ComingSoonTooltip
        className={classNames(styles.comingSoon, className)}
        isRtl={isRtl}
        place={isRtl ? 'left' : 'right'}
        tooltipClassName={styles.comingSoonTooltip}
        tooltipId={id}
    >
        {children}
    </ComingSoonTooltip>
);

MenuItemTooltip.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    id: PropTypes.string,
    isRtl: PropTypes.bool
};
let isSendPageView = false;
class MenuBar extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleClickNew',
            'handleClickRemix',
            'handleClickSave',
            'handleClickSaveAsCopy',
            'handleClickSeeCommunity',
            'handleClickShare',
            'handleCloseFileMenuAndThen',
            'handleLanguageMouseUp',
            'handleRestoreOption',
            'restoreOptionMessage',
            'handleResetProject',
            'handleUpdateProjectTitle'
        ]);
    }
    componentWillMount () {
        const entryTime = Date.now()
        window.addEventListener('beforeunload', () => {
            scratchView('view_xiaohou_code_editor_duration', {
                language: 'Scratch',
                editor: 'Scratch编辑器',
                scene: '社区创作',
                bundle_id: '',
                question_id: '',
                duration_time: Date.now() - entryTime
            });
        })
        // this.props.onOpenShareModal();
    }
    componentWillReceiveProps () {
        if (!isSendPageView &&
            this.props.canShareProj &&
            this.props.canShare &&
            this.props.projectId !== '0' &&
            (this.props.isShowingProject || this.props.isUpdating)
        ) {
            isSendPageView = true;
            scratchView('view_xiaohou_code_editor', {
                language: 'Scratch',
                editor: 'Scratch编辑器',
                scene: '社区创作',
                bundle_id: '',
                question_id: ''
            });
        }
    }
    handleClickNew () {
        let readyToReplaceProject = true;
        // if the project is dirty, and user owns the project, we will autosave.
        // but if they are not logged in and can't save, user should consider
        // downloading or logging in first.
        // Note that if user is logged in and editing someone else's project,
        // they'll lose their work.
        if (this.props.projectChanged && !this.props.canCreateNew) {
            readyToReplaceProject = confirm( // eslint-disable-line no-alert
                this.props.intl.formatMessage(messages.confirmNav)
            );
        }
        this.props.onRequestCloseFile();
        if (readyToReplaceProject) {
            // this.props.onClickNew(this.props.canSave && this.props.canCreateNew);
            this.props.onClickNewWithoutChangeId(this.props.canSave && this.props.canCreateNew);
        }
        this.props.onRequestCloseFile();
    }
    handleClickRemix () {
        this.props.onClickRemix();
        this.props.onRequestCloseFile();
    }

    handleUpdateProjectTitle (title, ...args) {
        this.props.onUpdateProjectTitle(title, ...args);
    }

    handleClickSave () {
        if (!this.props.canSaveProj) {
            swal.noAccess();
            return;
        }
        this.props.onClickSave();
        
        this.props.onRequestCloseFile();
    }
    handleClickSaveAsCopy () {
        this.props.onClickSaveAsCopy();
        this.props.onRequestCloseFile();
    }

    resetProject () {
        const id = this.props.projectId;
        axios.put(`${projectHost.projectHost}/resetScratchExercise/${id}`)
            .then(() => {
                swal.succ(errorMsg.RESET_SUCCESS)
                    .then(() => {
                        const hashMatch = window.location.hash.match(/#(\d+)/);
                        if (hashMatch === null) {
                            window.location.href += '#' + id;
                        } 
                        window.location.reload();
                    });
            })
            .catch(error => {
                swal.swalAgent(error, errorMsg.RESET_FAILED);
            });
    }

    // 重置
    handleResetProject () {
        if (!this.props.canResetProj) {
            swal.noAccess();
            return;
        }
        swal.swal({
            title: '确定重置代码吗？',
            text: '你对代码所做的更改都会清除并且恢复原状。',
            icon: 'warning',
            buttons: ['取消', '确定'],
            dangerMode: true
        })
            .then(willReset => {
                
                if (willReset) {
                    this.resetProject();
                }
            });
    }

    handleClickSeeCommunity (waitForUpdate) {
        if (this.props.canSave) { // save before transitioning to project page
            this.props.autoUpdateProject();
            waitForUpdate(true); // queue the transition to project page
        } else {
            waitForUpdate(false); // immediately transition to project page
        }
    }
    async handleClickShare () {
        if (this.props.isLoadingUpload) {
            swal.toast('素材正在上传，请稍后分享~');
            return;
        }
        // 内容检测依赖 CDN URL；未保存时 assetId 仍是纯 md5，会误走 common/mit
        try {
            await projectHost.ensureAssetsUploaded(this.props.vm);
        } catch (e) {
            swal.toast((e && e.message) || '资源上传失败，请稍后重试');
            return;
        }
        const {author_id: authorId} = this.props.projectDatafromNet || {};
        const {realName: authorName} = getUserinfo() || {};

        const getCheckStatus = result => {
            if (result?.data?.data?.status !== undefined) return result.data.data.status;
            if (result?.data?.status !== undefined) return result.data.status;
            return null;
        };
        const getAssetMd5 = (asset, url) => {
            if (asset?.md5ext) {
                return asset.md5ext.split('.')[0];
            }
            if (url) {
                const fileName = url.split('?')[0].split('/').pop() || '';
                const parts = fileName.split('.');
                if (parts.length > 1) {
                    parts.pop();
                    return parts.join('.');
                }
                return fileName;
            }
            return asset?.assetId || '';
        };
        const getOssMd5 = async url => {
            try {
                const res = await fetch(url, {method: 'HEAD'});
                const etag = res.headers.get('ETag');
                return etag ? etag.replace(/['"]/g, '').toLowerCase() : null;
            } catch {
                return null;
            }
        };
        const pollCheck = async params => {
            const startTime = Date.now();
            const timeout = 300000;
            while (Date.now() - startTime < timeout) {
                const result = await axios.post(`${API_BASE_URL}/core/safeCheck/guardian/check`, params);
                const status = getCheckStatus(result);
                if (status === 3 || status === 4 || status === 5) return result;
                if (status !== 1 && status !== 2) return result;
                await new Promise(resolve => window.setTimeout(resolve, 3000));
            }
            throw new Error('guardian/check timeout');
        };

        // 校验 vm.targets 中所有 costume 图片资源和音频资源
        const targets = this.props.vm.runtime.targets;
        const imageCheckTasks = [];
        const audioCheckTasks = [];
        for (const target of Object.values(targets)) {
            const costumes = target.sprite ? target.sprite.costumes : [];
            for (const costume of costumes) {
                const asset = costume.asset;
                if (!asset) continue;
                const url = projectHost.getAssetGetConfig(asset).url;
                imageCheckTasks.push(
                    (async () => {
                        const md5 = await getOssMd5(url) || getAssetMd5(asset, url);
                        const format = (asset.dataFormat || '').toUpperCase();
                        const textCheckRes = await axios.post(
                            `${API_BASE_URL}/core/safeCheck/guardian/check/text`,
                            {url: costume.name, module: 6}
                        );
                        if (getCheckStatus(textCheckRes) === 4) {
                            return {textCheckFailed: true, format};
                        }
                        const result = await pollCheck({
                            type: 1,
                            url,
                            md5,
                            module: 1,
                            authorId,
                            authorName,
                            role: this.props.role,
                            businessId: md5
                        });
                        return {result, format};
                    })()
                );
            }
            const sounds = target.sprite ? target.sprite.sounds : [];
            for (const sound of sounds) {
                const asset = sound.asset;
                if (!asset) continue;
                const url = projectHost.getAssetGetConfig(asset).url;
                audioCheckTasks.push(
                    (async () => {
                        const md5 = await getOssMd5(url) || getAssetMd5(asset, url);
                        const format = (asset.dataFormat || '').toUpperCase();
                        const textCheckRes = await axios.post(
                            `${API_BASE_URL}/core/safeCheck/guardian/check/text`,
                            {url: sound.name, module: 6}
                        );
                        if (getCheckStatus(textCheckRes) === 4) {
                            return {textCheckFailed: true, format};
                        }
                        const result = await pollCheck({
                            type: 2,
                            url,
                            md5,
                            module: 2,
                            authorId,
                            authorName,
                            role: this.props.role,
                            businessId: md5
                        });
                        return {result, format};
                    })()
                );
            }
        }
        if (audioCheckTasks.length > 0) {
            swal.toast('已提交审核（预计2~5分钟）。审核结果将更新在本页面，请稍后返回此页查看', 8000);
        }
        const failedItems = [];
        if (imageCheckTasks.length > 0) {
            try {
                const imageResults = await Promise.all(imageCheckTasks);
                const imageTextFailedItems = imageResults.filter(r => r && r.textCheckFailed);
                const imageFailedItems = imageResults.filter(r => r && r.result && getCheckStatus(r.result) === 4);
                imageTextFailedItems.forEach(item => {
                    failedItems.push({type: '素材图片', format: item.format});
                });
                imageFailedItems.forEach(item => {
                    failedItems.push({type: '素材图片', format: item.format});
                });
            } catch (error) {
                console.error('videoCheck image error:', error);
                await swal.alert('提示', '图片资源校验失败，请稍后重试');
                return;
            }
        }
        if (audioCheckTasks.length > 0) {
            try {
                const audioResults = await Promise.all(audioCheckTasks);
                const audioTextFailedItems = audioResults.filter(r => r && r.textCheckFailed);
                const audioFailedItems = audioResults.filter(r => r && r.result && getCheckStatus(r.result) === 4);
                audioTextFailedItems.forEach(item => {
                    failedItems.push({type: '素材音频', format: item.format});
                });
                audioFailedItems.forEach(item => {
                    failedItems.push({type: '素材音频', format: item.format});
                });
            } catch (error) {
                console.error('videoCheck audio error:', error);
                await swal.alert('提示', '音频资源校验失败，请稍后重试');
                return;
            }
        }
        if (failedItems.length > 0) {
            const failedTypes = [...new Set(
                failedItems
                    .map(item => (item.type || '').trim())
                    .filter(Boolean)
            )];
            const failedFormats = [...new Set(
                failedItems
                    .map(item => (item.format || '').trim().toUpperCase())
                    .filter(Boolean)
            )];
            const failedMessages = `${failedTypes.join('、')}${failedFormats.length ? `(${failedFormats.join('、')})` : ''}`;
            await swal.alert('提示', `${failedMessages}不符合平台的发布规范，请修改后分享`);
            return;
        }

        this.props.autoUpdateProject();
        setTimeout(() => this.handleSaved());
    }
    handleSaved () {
        const loop = () => setTimeout(() => {
            if (this.props.isUpdating) {
                loop()
            } else {
                if (getUserToken()) this.props.onOpenShareModal();
            }
        }, 100)
        loop()
    }
    handleRestoreOption (restoreFun) {
        return () => {
            restoreFun();
            this.props.onRequestCloseEdit();
        };
    }
    handleCloseFileMenuAndThen (fn) {
        return () => {
            this.props.onRequestCloseFile();
            fn();
        };
    }
    handleLanguageMouseUp (e) {
        if (!this.props.languageMenuOpen) {
            this.props.onClickLanguage(e);
        }
    }
    restoreOptionMessage (deletedItem) {
        switch (deletedItem) {
        case 'Sprite':
            return (<FormattedMessage
                defaultMessage="Restore Sprite"
                description="Menu bar item for restoring the last deleted sprite."
                id="gui.menuBar.restoreSprite"
            />);
        case 'Sound':
            return (<FormattedMessage
                defaultMessage="Restore Sound"
                description="Menu bar item for restoring the last deleted sound."
                id="gui.menuBar.restoreSound"
            />);
        case 'Costume':
            return (<FormattedMessage
                defaultMessage="Restore Costume"
                description="Menu bar item for restoring the last deleted costume."
                id="gui.menuBar.restoreCostume"
            />);
        default: {
            return (<FormattedMessage
                defaultMessage="Restore"
                description="Menu bar item for restoring the last deleted item in its disabled state." /* eslint-disable-line max-len */
                id="gui.menuBar.restore"
            />);
        }
        }
    }
    a (position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset) {
        console.log(position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
        return position;
    }
    render () {
        const {
            canSaveProj,
            canResetProj,
            canShareProj,
            canNewProject,
            canUpload,
            onCloseShareModal,
            shareModalVisible
        } = this.props;
        const saveNowMessage = (
            <FormattedMessage
                defaultMessage="Save now"
                description="Menu bar item for saving now"
                id="gui.menuBar.saveNow"
            />
        );
        const remixMessage = (
            <FormattedMessage
                defaultMessage="Remix"
                description="Menu bar item for remixing"
                id="gui.menuBar.remix"
            />
        );
        const newProjectMessage = (
            <FormattedMessage
                defaultMessage="New"
                description="Menu bar item for creating a new project"
                id="gui.menuBar.new"
            />
        );
        const uploadMessage = (
            <FormattedMessage
                defaultMessage="Load from your computer"
                description="Menu bar item for uploading a project from your computer"
                id="gui.menuBar.uploadFromComputer"
            />
        );
        const downloadMessage = (
            <FormattedMessage
                defaultMessage="Save to your computer"
                description="Menu bar item for downloading a project to your computer"
                id="gui.menuBar.downloadToComputer"
            />
        );
        const remixButton = (
            <Button
                className={classNames(
                    styles.menuBarButton,
                    styles.remixButton
                )}
                iconClassName={styles.remixButtonIcon}
                iconSrc={remixIcon}
                onClick={this.handleClickRemix}
            >
                {remixMessage}
            </Button>
        );
        const SBFileUploaderComponent = canUpload ?
            (
                <SBFileUploader canSave onUpdateProjectTitle={this.handleUpdateProjectTitle}>
                    {(className, renderFileInput, loadProject) => (
                        <MenuItem
                            className={className}
                            onClick={loadProject}
                        >
                            {uploadMessage}
                            {renderFileInput()}
                        </MenuItem>
                    )}
                </SBFileUploader>
            ) : <div />;

        return (
            <Box
                className={classNames(
                    this.props.className,
                    styles.menuBar
                )}
            >
                <div className={styles.mainMenu}>
                    <div className={styles.fileGroup}>
                        <div className={classNames(styles.menuBarItem)}>
                            <img
                                alt="logo"
                                className={classNames(styles.scratchLogo, {
                                    [styles.clickable]: typeof this.props.onClickLogo !== 'undefined'
                                })}
                                draggable={false}
                                src={logo}
                                onClick={this.props.onClickLogo}
                            />
                            {/* eslint-disable-next-line */}
                        </div>
                        {/* 多语言切换 */}
                        {/* <div
                            className={classNames(styles.menuBarItem, styles.hoverable, styles.languageMenu)}
                        >
                            <div>
                                <img
                                    className={styles.languageIcon}
                                    src={languageIcon}
                                />
                                <img
                                    className={styles.languageCaret}
                                    src={dropdownCaret}
                                />
                            </div>
                            <LanguageSelector label={this.props.intl.formatMessage(ariaMessages.language)} />
                        </div> */}
                        <div
                            className={classNames(styles.menuBarItem, styles.hoverable, {
                                [styles.active]: this.props.fileMenuOpen
                            })}
                            onMouseUp={this.props.onClickFile}
                        >
                            <FormattedMessage
                                defaultMessage="File"
                                description="Text for file dropdown menu"
                                id="gui.menuBar.file"
                            />
                            <MenuBarMenu
                                className={classNames(styles.menuBarMenu)}
                                open={this.props.fileMenuOpen}
                                place={this.props.isRtl ? 'left' : 'right'}
                                onRequestClose={this.props.onRequestCloseFile}
                            >
                                {canNewProject &&
                                    <MenuSection>
                                        <MenuItem
                                            isRtl={this.props.isRtl}
                                            onClick={this.handleClickNew}
                                        >
                                            {newProjectMessage}
                                        </MenuItem>
                                    </MenuSection>
                                }
                                {canResetProj &&
                                    <MenuSection>
                                        <MenuItem
                                            isRtl={this.props.isRtl}
                                            onClick={this.handleResetProject}
                                        >
                                            {'重置'}
                                        </MenuItem>
                                    </MenuSection>
                                }
                                <MenuSection>
                                       
                                    <MenuItem onClick={this.handleClickSave}>
                                        {saveNowMessage}
                                    </MenuItem>
                                   
                                </MenuSection>
                                <MenuSection>
                                    {SBFileUploaderComponent}
                                    <SB3Downloader onSaveFinished={this.handleClickSave}>
                                        {(className, downloadProject) => (
                                            <MenuItem
                                                className={className}
                                                onClick={this.handleCloseFileMenuAndThen(downloadProject)}
                                            >
                                                {downloadMessage}
                                            </MenuItem>
                                        )}
                                    </SB3Downloader>
                                </MenuSection>
                            </MenuBarMenu>
                        </div>
                    </div>
                </div>

                {/* show the proper UI in the account menu, given whether the user is
                logged in, and whether a session is available to log in with */}
                <div className={styles.accountInfoGroup}>
                    <div className={styles.menuBarItem}>
                        {this.props.canSave && (
                            <SaveStatus />
                        )}
                    </div>
                    {this.props.canEditTitle ? (
                        <div className={classNames(styles.menuBarItem, styles.growable, styles.title)}>
                            <MenuBarItemTooltip
                                enable
                                id="title-field"
                            >
                                <ProjectTitleInput
                                    className={classNames(styles.titleFieldGrowable)}
                                    onUpdateProjectTitle={this.handleUpdateProjectTitle}
                                />
                            </MenuBarItemTooltip>
                        </div>
                    ) : ((this.props.authorUsername && this.props.authorUsername !== this.props.username) ? (
                        <AuthorInfo
                            className={styles.authorInfo}
                            imageUrl={this.props.authorThumbnailUrl}
                            projectTitle={this.props.projectTitle}
                            userId={this.props.authorId}
                            username={this.props.authorUsername}
                        />
                    ) : null)}

                        
                    {(canShareProj &&
                            this.props.canShare &&
                            this.props.projectId !== '0') && (
                        (this.props.isShowingProject || this.props.isUpdating) && (
                            <div
                                className={classNames(
                                    styles.menuBarItem,
                                    styles.menuBarShare,
                                )}
                            >
                                {/* <ShareTip /> */}
                                <div
                                    className={styles.hoverable}
                                    onClick={this.handleClickShare}
                                >
                                    {'分享'}
                                </div>
                                {this.props.canRemix ? remixButton : []}
                            </div>
                        )
                    )}

                    {canSaveProj &&
                        <div
                            className={classNames(
                                styles.menuBarItem,
                                styles.hoverable
                            )}
                            onClick={this.handleClickSave}
                        >{'保存'}
                        </div>
                    }
                    { <span className={classNames(styles.eyecare, styles.eyes_green)}>
                        <div
                            className={styles.eyecare_icon}
                            data-for={'eyescare'}
                            data-tip={'护眼模式已开启'}
                        />
                        <span className={styles.eyecare_tip}>{'护眼模式已开启'}</span>
                        <ReactTooltip
                            className={styles.tooltip}
                            effect="solid"
                            type="light"
                            id={'eyescare'}
                            place={'bottom'}
                            // eslint-disable-next-line react/jsx-no-bind
                            overridePosition={(position,
                                currentEvent, currentTarget, node, place, desireplace) => {
                                if (place === desireplace) {
                                    return position;
                                } return {
                                    left: 40,
                                    top: 28
                                };
                            }}
                        />
                    </span>}


                    {this.props.sessionExists ? (
                        this.props.username ? (
                            // ************ user is logged in ************
                            <React.Fragment>
                                <a href="/mystuff/">
                                    <div
                                        className={classNames(
                                            styles.menuBarItem,
                                            styles.hoverable,
                                            styles.mystuffButton
                                        )}
                                    >
                                        <img
                                            className={styles.mystuffIcon}
                                            src={mystuffIcon}
                                        />
                                    </div>
                                </a>
                                <AccountNav
                                    className={classNames(
                                        styles.menuBarItem,
                                        styles.hoverable,
                                        {[styles.active]: this.props.accountMenuOpen}
                                    )}
                                    isOpen={this.props.accountMenuOpen}
                                    isRtl={this.props.isRtl}
                                    menuBarMenuClassName={classNames(styles.menuBarMenu)}
                                    onClick={this.props.onClickAccount}
                                    onClose={this.props.onRequestCloseAccount}
                                    onLogOut={this.props.onLogOut}
                                />
                            </React.Fragment>
                        ) : (
                            // ********* user not logged in, but a session exists
                            // ********* so they can choose to log in
                            <React.Fragment>
                                <div
                                    className={classNames(
                                        styles.menuBarItem,
                                        styles.hoverable
                                    )}
                                    key="join"
                                    onMouseUp={this.props.onOpenRegistration}
                                >
                                    <FormattedMessage
                                        defaultMessage="Join Scratch"
                                        description="Link for creating a Scratch account"
                                        id="gui.menuBar.joinScratch"
                                    />
                                </div>
                                <div
                                    className={classNames(
                                        styles.menuBarItem,
                                        styles.hoverable
                                    )}
                                    key="login"
                                    onMouseUp={this.props.onClickLogin}
                                >
                                    <FormattedMessage
                                        defaultMessage="Sign in"
                                        description="Link for signing in to your Scratch account"
                                        id="gui.menuBar.signIn"
                                    />
                                    <LoginDropdown
                                        className={classNames(styles.menuBarMenu)}
                                        isOpen={this.props.loginMenuOpen}
                                        isRtl={this.props.isRtl}
                                        renderLogin={this.props.renderLogin}
                                        onClose={this.props.onRequestCloseLogin}
                                    />
                                </div>
                            </React.Fragment>
                        )
                    ) : (
                        // ******** no login session is available, so don't show login stuff
                        <React.Fragment>
                            {/* <div className={classNames(styles.menuBarItem, styles.feedbackButtonWrapper)}>
                                <a
                                    className={styles.feedbackLink}
                                    href="https://scratch.mit.edu/discuss/topic/312261/"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <Button
                                        className={styles.feedbackButton}
                                        iconSrc={feedbackIcon}
                                    >
                                        <FormattedMessage
                                            defaultMessage="Give Feedback"
                                            description="Label for feedback form modal button"
                                            id="gui.menuBar.giveFeedback"
                                        />
                                    </Button>
                                </a>
                            </div> */}
                            {this.props.showComingSoon ? (
                                <React.Fragment>
                                    {/* <MenuBarItemTooltip id="mystuff">
                                        <div
                                            className={classNames(
                                                styles.menuBarItem,
                                                styles.hoverable,
                                                styles.mystuffButton
                                            )}
                                        >
                                            <img
                                                className={styles.mystuffIcon}
                                                src={mystuffIcon}
                                            />
                                        </div>
                                    </MenuBarItemTooltip> */}
                                    {/* <MenuBarItemTooltip
                                        id="account-nav"
                                        place={this.props.isRtl ? 'right' : 'left'}
                                    >
                                        <div
                                            className={classNames(
                                                styles.menuBarItem,
                                                styles.hoverable,
                                                styles.accountNavMenu
                                            )}
                                        >
                                            <img
                                                className={styles.profileIcon}
                                                src={profileIcon}
                                            />
                                            <span>
                                                {'scratch-cat'}
                                            </span>
                                            <img
                                                className={styles.dropdownCaretIcon}
                                                src={dropdownCaret}
                                            />
                                        </div>
                                    </MenuBarItemTooltip> */}
                                </React.Fragment>
                            ) : []}
                        </React.Fragment>
                    )}
                </div>
                {this.props.record.start && <MediaRecordModal
                    onSetStopRecord={this.props.onSetStopRecord}
                    record={this.props.record}
                    shareModalVisible={shareModalVisible}
                    onCloseShareModal={onCloseShareModal}
                    onOpenShareModal={this.props.onOpenShareModal}
                />}
            </Box>
        );
    }
}

MenuBar.propTypes = {
    accountMenuOpen: PropTypes.bool,
    authorId: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    authorThumbnailUrl: PropTypes.string,
    authorUsername: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    autoUpdateProject: PropTypes.func,
    // canCreateCopy: PropTypes.bool,
    canCreateNew: PropTypes.bool,
    canEditTitle: PropTypes.bool,
    canPublishProj: PropTypes.bool,
    canRemix: PropTypes.bool,
    canResetProj: PropTypes.bool,
    canSave: PropTypes.bool,
    canSaveProj: PropTypes.bool,
    canShare: PropTypes.bool,
    canShareProj: PropTypes.bool,
    canNewProject: PropTypes.bool,
    canUpload: PropTypes.bool,
    className: PropTypes.string,
    editMenuOpen: PropTypes.bool,
    // enableCommunity: PropTypes.bool,
    fileMenuOpen: PropTypes.bool,
    intl: intlShape,
    isPublish: PropTypes.bool,
    isRtl: PropTypes.bool,
    isShared: PropTypes.bool,
    isShowingProject: PropTypes.bool,
    isLoadingUpload: PropTypes.bool,
    isUpdating: PropTypes.bool,
    languageMenuOpen: PropTypes.bool,
    loginMenuOpen: PropTypes.bool,
    onClickAccount: PropTypes.func,
    onClickEdit: PropTypes.func,
    onClickFile: PropTypes.func,
    onClickLanguage: PropTypes.func,
    onClickLogin: PropTypes.func,
    onClickLogo: PropTypes.func,
    onClickNew: PropTypes.func,
    onClickPublish: PropTypes.func,
    onClickRemix: PropTypes.func,
    // setProjectId: PropTypes.func,
    onClickSave: PropTypes.func,
    onClickSaveAsCopy: PropTypes.func,
    onLogOut: PropTypes.func,
    onOpenRegistration: PropTypes.func,
    onOpenShareModal: PropTypes.func,
    // onOpenTipLibrary: PropTypes.func,
    onRequestCloseAccount: PropTypes.func,
    onRequestCloseEdit: PropTypes.func,
    onRequestCloseFile: PropTypes.func,
    // onRequestCloseLanguage: PropTypes.func,
    onRequestCloseLogin: PropTypes.func,
    onSeeCommunity: PropTypes.func,
    onShare: PropTypes.func,
    // onToggleLoginOpen: PropTypes.func,
    onUpdateProjectTitle: PropTypes.func,
    projectChanged: PropTypes.bool,
    projectTitle: PropTypes.string,
    projectId: PropTypes.string,
    renderLogin: PropTypes.func,
    // saveStatus:PropTypes.bool,
    // showShare: PropTypes.bool,
    // submitStatus: PropTypes.bool,
    // setSubmitStatus: PropTypes.func,
    sessionExists: PropTypes.bool,
    showComingSoon: PropTypes.bool,
    username: PropTypes.string,
    // resetProject: PropTypes.fun,
    onCloseShareModal: PropTypes.func,
    shareModalVisible: PropTypes.bool,
    // eslint-disable-next-line react/forbid-prop-types
    record: PropTypes.object,
    onSetStopRecord: PropTypes.func
};

MenuBar.defaultProps = {
    onShare: () => {}
};

const mapStateToProps = state => {
    const loadingState = state.scratchGui.projectState.loadingState;
    const user = state.session && state.session.session && state.session.session.user;
    let projectId = state.scratchGui.projectState.projectId;
    return {
        accountMenuOpen: accountMenuOpen(state),
        canSaveProj: state.scratchGui.searchArgs.canSaveProj,
        canPublishProj: state.scratchGui.searchArgs.canPublishProj,
        canResetProj: state.scratchGui.searchArgs.canResetProj,
        canShareProj: state.scratchGui.searchArgs.canShareProj,
        canNewProject: state.scratchGui.searchArgs.canNewProject,
        canUpload: state.scratchGui.searchArgs.canUpload,
        fileMenuOpen: fileMenuOpen(state),
        editMenuOpen: editMenuOpen(state),
        showShare: showShare(state),
        isRtl: state.locales.isRtl,
        isLoadingUpload: getIsLoadingUpload(loadingState) || state.scratchGui.isAssetUploading.isAssetUploading,
        isUpdating: getIsUpdating(loadingState),
        isPublish: getIsPublish(loadingState),
        isShowingProject: getIsShowingProject(loadingState),
        languageMenuOpen: languageMenuOpen(state),
        loginMenuOpen: loginMenuOpen(state),
        projectChanged: state.scratchGui.projectChanged,
        projectTitle: state.scratchGui.projectTitle,
        sessionExists: state.session && typeof state.session.session !== 'undefined',
        username: user ? user.username : null,
        projectId: state.scratchGui.projectState.projectId,
        submitStatus: state.scratchGui.isSubmitStatus.submitStatus,
        record: state.scratchGui.record,
        shareModalVisible: state.scratchGui.modals.shareModal,
        role: state.scratchGui.searchArgs.role,
        projectDatafromNet: state.scratchGui.getOriginData.projectDatafromNet,
        vm: state.scratchGui.vm,
    };
};

const mapDispatchToProps = dispatch => ({
    autoUpdateProject: () => dispatch(autoUpdateProject()),
    onOpenTipLibrary: () => dispatch(openTipsLibrary()),
    onClickAccount: () => dispatch(openAccountMenu()),
    onRequestCloseAccount: () => dispatch(closeAccountMenu()),
    onClickFile: () => dispatch(openFileMenu()),
    onRequestCloseFile: () => dispatch(closeFileMenu()),
    onClickEdit: () => dispatch(openEditMenu()),
    onRequestCloseEdit: () => dispatch(closeEditMenu()),
    onClickLanguage: () => dispatch(openLanguageMenu()),
    onRequestCloseLanguage: () => dispatch(closeLanguageMenu()),
    onClickLogin: () => dispatch(openLoginMenu()),
    onRequestCloseLogin: () => dispatch(closeLoginMenu()),
    onClickNew: needSave => dispatch(requestNewProject(needSave)),
    onClickRemix: () => dispatch(remixProject()),
    setProjectId: () => dispatch(setProjectId()),
    onClickPublish: () => dispatch(manualPublishProject()),
    onClickSave: () => dispatch(manualUpdateProject()),
    onClickSaveAsCopy: () => dispatch(saveProjectAsCopy()),
    onOpenShareModal: () => dispatch(openShareModal()),
    onSeeCommunity: () => dispatch(setPlayer(true)),
    setSubmitStatus: submitStatus => dispatch(setSubmitStatus(submitStatus)),
    onCloseShareModal: () => dispatch(closeShareModal()),
    onSetStopRecord: () => dispatch(setStartRecord(false)),
    onClickNewWithoutChangeId: needSave => dispatch(requestNewProjectWithoutChangeId(needSave)),
});

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(MenuBar));
